import { Component, TemplateFunction } from '@ribajs/core'
import { SidebarState } from '../types/index.js'
import type { JsxSbSidebarButtonProps } from '../types/jsx'
import type { SbSidebarComponent } from './sb-sidebar.component.js'

/**
 * A custom sidebar button element to toggle any sidebar by `target`
 */
export class SbSidebarButtonComponent extends Component {
  public static tagName = 'sb-sidebar-button'

  protected sidebar?: SbSidebarComponent

  static get observedAttributes(): (keyof JsxSbSidebarButtonProps)[] {
    return ['target']
  }

  protected requiredAttributes(): string[] {
    return ['target']
  }

  public scope = {
    // Options
    /** The target sidebar id */
    target: '',
    // Methods
    hide: this.hide,
    show: this.show,
    toggle: this.toggle,

    hidden: true,
  }

  public getState() {
    return this.sidebar?.getState()
  }

  public hide() {
    this.sidebar?.hide()
  }

  public show() {
    this.sidebar?.show()
  }

  public toggle(e: Event) {
    e.preventDefault()
    this.sidebar?.toggle()
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbSidebarButtonComponent.observedAttributes)
  }

  protected _onStateChange(event: CustomEvent<SidebarState>) {
    this.scope.hidden = event.detail === 'hidden'
  }
  onStateChange = this._onStateChange.bind(this)

  protected async afterBind() {
    await super.afterBind()
    this.initSidebar()
    this.classList.add(`${SbSidebarButtonComponent.tagName}-ready`)
  }

  protected initSidebar() {
    this.sidebar =
      document.querySelector(`sb-sidebar[id='${this.scope.target}']`) ||
      undefined
    if (!this.sidebar) {
      throw new Error(
        `sb-sidebar element with id "${this.scope.target}" not found!`,
      )
    }
    this.sidebar.removeEventListener('state-changed' as any, this.onStateChange)
    this.sidebar.addEventListener('state-changed' as any, this.onStateChange)
    this.scope.hidden = this.sidebar.getState() === 'hidden'
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
